export default __webpack_public_path__ + "static/media/SUR-01.f12e94bd.png";